module.exports = __webpack_public_path__ + "img/kids-hero.4577f29b.jpg";